import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import BackComponent from 'screens/back';
import { Table, Pagination, Tooltip, Input, CheckboxTable, Modal, Select, Textarea, Button, PaperClip } from 'components';
import { CameraIcon, CalendarIcon, ClockIcon, AlertIcon, CloseIcon, LocationIcon, PinIcon, TrashIcon, ViewIcon, CleanIcon, AddWhiteIcon, TrashWhiteIcon, ConfirmIcon, StarIcon, GoogleMapsIcon, ArrowLeftBlack, ArrowRightBlack, EditIcon, CheckGreenIcon, CheckWhiteIcon, ArrowLeft } from 'assets/icons';
import { Globals, checkPermission, Constants } from 'utils';
import RequestQuote from '../request-quote';
import { RequestQuoteFormImage, IncludeImage, IncludeAllImage, SprayImage } from 'assets/img';
import { ClientQuoteService, ProfileService, ClientProfileService } from 'services';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import moment from 'moment';
import addCurrentLocation from 'google-maps-current-location';
import ModalConfirm from './modal-confirm';
import ModalPayment from './modal-payment';
import ReactHtmlParser from 'react-html-parser';
import ModalSuccess from './modal-success';
import ModalLogin from './modal-login';
import ModalRegister from './modal-register';
import ModalReset from './modal-reset';
import ModalVerifyAccount from './modal-verify-account';
import Header from 'screens/header';

const { REACT_APP_LINK_SPLENDOR: SplendorURL } = process.env;
const MAX_PHOTOS = 10;

interface MatchParams {
	service_id: string
}

interface Props extends RootState, RouteComponentProps<MatchParams> {
	dispatch: any
}

const ADDRESS_TYPES = {
	CONFIRM: 1,
	NEW: 2
}

const DEFAULT_LOCATION = {
	latitude: '10.48801',
	longitude: '-66.87919'
}

const INITIAL_STATE	= {
	state_id: '',
	city_id: '',
	municipality_id: '',
	address: '',
	indications: '',
	information: '',
	name: '',
	latitude: '10.48801',
	longitude: '-66.87919'
}

declare var window: any;

// @ts-ignore
const google = window.google;

const INITIAL_STATE_FORM = {
	area_id: '',
	comments: '',
	city: '',
	date: moment().add(2,'days').format('YYYY-MM-DD'),
	journey_id: '',
	discount_code: '',
	type_id: '',
	area: ''
}

class ClientRequestQuote extends React.Component<Props> {

	calendar: any;

	state = {
		currentYear: moment().format('YYYY'),
		currentMonth: moment().format('MMMM'),
		service: null,
		form: INITIAL_STATE_FORM,
		journeys: [],
		latitude: this.props.user?.latitude || null,
		longitude: this.props.user?.longitude || null,
		address_type: ADDRESS_TYPES.NEW,
		error_map: false,
		visible_view: false,
		item: null,
		visible_payment: false,
		holidays: [],
		special_days: [],
		quotes: [],
		loading_journeys: false,
		item_to_url: '',
		user_addresses: [],
		add_new: false,
		states: [],
		cities: [],
		municipalities: [],
		user_address: INITIAL_STATE,
		active_index: null,
		selected_address: null,
		quote_types: [],
		price_per_meter: null,
		urgent_prices: [],
		accessories: [],
		urgent_available: true,
		multiples_dates: false,
		days_selected: [],
		surcharges: 0,
		special_day_price: 0,
		special_day_price_accessories: 0,
		items_marquee: [],
		items_marquee_included: [],
		items_marquee_not_included: [],
		excluded_places: [],
		journey_surcharge: 0,
		quote_limit: 4,
		services: [],
		visible_calendar: false,
		service_id: this.props.match.params.service_id,
		months: [],
		default_journey: null,
		quote_before_login: null,
		discount: null,
		conversion: 0,
		photos: [],
		visible_success: false,
		visible_login: false,
		visible_register: false,
		visible_reset: false,
		visible_verify_account: false
	}

	async componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: '',
				onBack: () => {
					this.props.history.replace('/client/quotes');
				}
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		const item = this.props.quote_before_login;
		await this.props.dispatch({
			type: 'SET_QUOTE_BEFORE_LOGIN',
			payload: null
		});

		if (item) {
			const days_selected = item?.item?.days_selected.filter((i: any) => moment(i) > moment().add(2,'days'));

			await this.setState({
				quote_before_login: item,
				service_id: item?.item?.service_id || this.props.match.params.service_id,
				form: {
					...this.state.form,
					type_id: item?.item?.type_id || '',
					date: item?.item?.date || moment().add(2,'days').format('YYYY-MM-DD'),
					comments: item?.item?.comments || '',
					user_address: item?.item?.user_address ? JSON.parse(item?.item?.user_address) : INITIAL_STATE,
					area_id: item?.item?.area_id || '',
					area: item?.item?.area || ''
				},
				multiples_dates: item?.item?.multiples_dates || false,
				days_selected: days_selected || [],
				user_addresses: item?.user_addresses || [],
				selected_address: item?.item?.selected_address !== null ? item?.item?.selected_address : null
			},() => {
				this.updateAddresses();
			});
		}

		this.verifyValidate();
		this.requestLocation();
		this.load();

		let months = [];
		for (let i = 1; i <= 12; i++) {
			months.push({
				value: moment(i,'M').format('MMMM'),
				label: Globals.capitalize(moment(i,'M').format('MMMM'))
			})
		}

		let items_marquee: any = [...this.state.items_marquee];
		for (let i = 15; i <= 19; i++) {
			items_marquee.push(require(`assets/img/marquee/marquee-${ i }.png`));
		}
		let items_marquee_included: any = [...this.state.items_marquee_included];
		for (let i = 1; i <= 6; i++) {
			items_marquee_included.push(require(`assets/img/marquee/included${ i }.png`));
		}
		let items_marquee_not_included: any = [...this.state.items_marquee_not_included];
		for (let i = 0; i <= 7; i++) {
			items_marquee_not_included.push(require(`assets/img/marquee/not-included${ i }.png`));
		}
		this.setState({
			items_marquee,
			months,
			items_marquee_not_included,
			items_marquee_included
		});
	}

	verifyValidate = () => {
		if (this.props.user && this.props.user?.level_id == Constants.LEVELS.CLIENT && this.props.user?.verified == Constants.VALIDATION_STATUS.INACTIVE) {
			this.setState({
				visible_verify_account: true
			});
		}
	}

	load = async (withoutLoading: boolean = false) => {
		let active_accessories: any = [];
		if (this.state.quote_before_login) {
			// @ts-ignore
			active_accessories = JSON.parse(this.state.quote_before_login?.item?.accessories);
		}

		const res: any = await ClientQuoteService.client.viewService({
			service_id: this.state.service_id,
			user_id: this.props.user?.owner_id || this.props.user?.id,
			withoutLoading
		});
		if (res.service) {
			if (res.survey_pending) {
				Globals.showWarning("Para solicitar un nuevo servicio, por favor llene la encuesta de satisfacción del último servicio realizado");
				this.props.history.replace('/survey/' + res.survey_pending?.code + '?return_to_quotes=' + this.state.service_id);
				return;
			}

			if (Globals.checkIfCorporate(this.props.user) || (this.props.user?.owner_id != null && this.props.user?.user_type_id == Constants.USER_TYPES.SUBUSER)) {
				if (res.service) {
					res.service.price = res.service?.price_corporate;
				}
				if (res.urgent_prices) {
					res.urgent_prices.forEach((item: any) => {
						if (item.price_corporate)
							item.price = item.price_corporate;
					});
				}
				if (res.accessories) {
					res.accessories.forEach((item: any) => {
						if (item.price_corporate)
							item.price = item.price_corporate;
					});
				}
				if (res.price_per_meter && res.price_per_meter.price_corporate)
					res.price_per_meter.price = res.price_per_meter.price_corporate;
			}

			if (res.quote_limit <= 0) {
				this.props.history.replace('/client/quotes');
				Globals.showError("Lo sentimos, ha llegado al límite de citas simultaneas");
				return;
			}

			if (res.accessories) {
				res.accessories.forEach((item: any) => {
					const index = active_accessories.map((i: any) => i.accessory_id).indexOf(item.id);
					if (index != -1) {
						item.quantity = active_accessories[index].quantity;
					}
				});
			}

			this.setState({
				service: res.service ? res.service : res.services.length > 0 ? res.services[0] : null,
				holidays: res.holidays,
				user_addresses: [...res.user_addresses,...this.state.user_addresses.filter((item: any) => item.id == null)],
				states: res.states,
				quote_types: res.quote_types,
				price_per_meter: res.price_per_meter,
				urgent_prices: res.urgent_prices,
				accessories: res.accessories,
				urgent_available: res.urgent_available,
				special_days: res.special_days || [],
				special_day_price: res.special_day_price || 0,
				special_day_price_accessories: res.special_day_price_accessories || 0,
				excluded_places: res.excluded_places || [],
				quote_limit: res.quote_limit || 4,
				services: res.services || [],
				default_journey: res.default_journey,
				conversion: res.conversion || 0,
				form: {
					...this.state.form,
					type_id: res.quote_types.length > 0 ? res.quote_types[0].id : ''
				}
			},() => {
				if (this.props.default_address) {
					const index_address = res.user_addresses.findIndex((i: any) => i.id == this.props.default_address);

					if (index_address != -1) {
						this.setState({
							selected_address: index_address
						});
					}
				}
				this.checkInitialDate();
				if (this.state.quote_before_login) {
					this.setState({
						// @ts-ignore
						user_addresses: this.state.quote_before_login?.user_addresses || this.state.user_addresses
					},() => {
						this.submit();
					});
				}
			});
		}
		else {
			this.props.history.replace('/client/quotes');
		}
	}

	back = () => {
		this.props.history.replace('/client/quotes');
	}

	checkInitialDate = () => {
		// @ts-ignore
		if (this.state.holidays.indexOf(this.state.form.date) != -1) {
			this.setState({
				form: {
					...this.state.form,
					date: moment(this.state.form.date).add(1,'day').format('YYYY-MM-DD')
				}
			},() => this.checkInitialDate());
		}
		else {
			if (!this.state.multiples_dates) {
				this.loadJourneys();
			}
			this.loadQuotesMonth();

			this.calculateSurcharges();
		}
	}

	loadJourneys = async () => {
		await this.setState({
			loading_journeys: true
		});
		const res: any = await ClientQuoteService.client.getJourneys({
			date: this.state.form.date && moment(this.state.form.date).format('YYYY-MM-DD'),
			// @ts-ignore
			service_id: this.state.service?.id,
			withoutLoading: true
		});
		this.setState({
			journeys: res.journeys,
			loading_journeys: false
		});
	}

	loadQuotesMonth = async () => {
		const res: any = await ClientQuoteService.client.getQuotesMonth({
			date: moment(this.state.currentYear + '-' + this.state.currentMonth,'YYYY-MMMM').startOf('month').format('YYYY-MM-DD'),
			// @ts-ignore
			service_id: this.state.service?.id,
			withoutLoading: true
		});
		this.setState({
			quotes: res.quotes
		});
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	updateDate = () => {
		this.setState({
			currentYear: moment(this.calendar?.getApi().getDate()).format('YYYY'),
			currentMonth: moment(this.calendar?.getApi().getDate()).format('MMMM')
		},() => {
			this.loadQuotesMonth();
		});
	}

	requestLocation = async () => {
		if (!this.state.latitude && !this.state.longitude) {
			try {
				if (window.webkit && window.webkit.messageHandlers) {
					await this.setState({
			  			latitude: '10.48801',
						longitude: '-66.87919'
			  		});

			  		if (google)
		    			this.setMap();
				}
				else {
					navigator.permissions.query({ name: "geolocation" }).then((permissionStatus) => {
						this.activeGeolocation();

						permissionStatus.onchange = async () => {
							await this.setState({
								error_map: false
							});
					        this.activeGeolocation();
					    }
					});
				}
			}
			catch(e) {
				this.activeGeolocation();
				console.log(e);
			}
		}
		else {
			if (google)
	    		this.setMap();
		}		
	}

	activeGeolocation = async () => {
  		await this.setState({
  			latitude: '10.48801',
			longitude: '-66.87919'
  		});

  		if (google)
			this.setMap();
	}

	setMap = async () => {
		const map = new google.maps.Map(document.getElementById('map-request-quote'), {
	      zoom: 13,
	      center: new google.maps.LatLng(this.state.user_address?.latitude || '10.48801',this.state.user_address?.longitude || '-66.87919'),
	      draggable: true,
	      zoomControl: true,
	      streetViewControl: false,
	      fullscreenControl: false,
	      scaleControl: false,
	      rotateControl: false
	    });

	    addCurrentLocation(map,{
		  markerStyle: {
			scale: 0
		  },
		  showAccuracyRadius: false
		});

	    const marker = new google.maps.Marker({
	      position: new google.maps.LatLng(this.state.user_address?.latitude || '10.48801',this.state.user_address?.longitude || '-66.87919'),
	      map,
	      title: 'Ubicación',
	      animation: google.maps.Animation.DROP,
	      draggable: true,
	      icon: PinIcon
	    })

	    await this.setState({
			map,
			marker
	    });

	    google.maps.event.addListener(marker,'dragend',(event: any) => {
	    	this.setState({
	    		user_address: {
	    			...this.state.user_address,
	    			latitude: event.latLng.lat(),
	    			longitude: event.latLng.lng()
	    		}
	    	});
	    });

	    google.maps.event.addListener(map,'click',(event: any) => {
	    	this.setState({
	    		user_address: {
	    			...this.state.user_address,
	    			latitude: event.latLng.lat(),
	    			longitude: event.latLng.lng()
	    		}
	    	});

	    	// @ts-ignore
	    	this.state.marker?.setPosition(new google.maps.LatLng(event.latLng.lat(),event.latLng.lng()));
	    });

	    const input = document.getElementById('location-input');
        const autocomplete = new google.maps.places.Autocomplete(input,{
        	componentRestrictions: {
        		country: "ve"
        	}
        });
        google.maps.event.addListener(autocomplete, 'place_changed', () => {
            var place = autocomplete.getPlace();
            const latitude = place.geometry.location.lat();
            const longitude = place.geometry.location.lng();
            this.setState({
            	user_address: {
            		...this.state.user_address,
            		latitude,
            		longitude
            	}
            });
            // @ts-ignore
            document.querySelector('#location-input').value = '';
            map.setCenter(new google.maps.LatLng(latitude,longitude));
            marker.setPosition(new google.maps.LatLng(latitude,longitude));
        });

        if (map) {
        	for (let i = 0; i < this.state.excluded_places.length; i++) {
	        	// @ts-ignore
	        	const coords = this.state.excluded_places[i].coords;

	        	new google.maps.Polygon({
			      paths: coords.map((i: any) => {
		    		return {
		    			lat: parseFloat(i.latitude),
		    			lng: parseFloat(i.longitude)
		    		}
			      }),
				  strokeColor: "#d20b06",
				  strokeOpacity: 0.8,
				  strokeWeight: 2,
				  fillColor: "#d20b06",
				  fillOpacity: 0.35,
				  map
			    });
	        }
        }
	}

	checkIfPolygonContains = (coords: any,polygon: any) => {
		return google.maps.geometry.poly.containsLocation(coords, polygon);
	}

	submit = async (discount_code: string = '') => {
		if (!this.state.form.type_id) {
			Globals.showError("Debe ingresar el tipo de servicio");
			return;
		}

		await this.setState({
			form: {
				...this.state.form,
				discount_code
			}
		});

		const price_per_meter: any = this.state.price_per_meter;
		const service: any = this.state.service;

		const area_limit = service?.service_areas?.filter((i: any) => {
			return (this.state.form.type_id == Constants.QUOTE_TYPES.CUSTOM.toString() && i.type_id == null) || (!Globals.isQuoteTypeBase(this.state.form.type_id) && i.type_id == this.state.form.type_id);
		}).find((item: any) => item.quantity != 0 && item.quantity != null && item.quantity != '' && item.limit != null && item.limit < item.quantity);

		if (area_limit) {
			if (!this.state.form.area) {
				Globals.showError(`La cantidad de ${ area_limit?.name } no puede ser mayor a ${ area_limit?.limit }`);
				return;
			}
		}

		if (this.state.form.type_id == Constants.QUOTE_TYPES.DEEP.toString()) {
			if (!this.state.form.area) {
				Globals.showError("Debe indicar la cantidad");
				return;
			}
		}
		else if (this.state.form.type_id == Constants.QUOTE_TYPES.URGENT.toString()) {
			if (!this.state.form.area) {
				Globals.showError("Debe indicar la cantidad");
				return;
			}
		}
		else if (this.state.form.type_id == Constants.QUOTE_TYPES.CUSTOM.toString() || !Globals.isQuoteTypeBase(this.state.form.type_id)) {
			// @ts-ignore
			if (this.state.service?.service_areas?.filter((i: any) => {
				return (this.state.form.type_id == Constants.QUOTE_TYPES.CUSTOM.toString() && i.type_id == null) || (!Globals.isQuoteTypeBase(this.state.form.type_id) && i.type_id == this.state.form.type_id);
			}).find((item: any) => item.quantity != 0 && item.quantity != '' && item.quantity != null) == null) {
				Globals.showError("Debe indicar la cantidad de al menos un área");
				return;
			}
		}

		if (this.state.selected_address == null) {
			Globals.showError("Debe seleccionar la dirección");
			return;
		}

		// @ts-ignore
		const user_address: any = this.state.user_addresses[this.state.selected_address];

		for (let i = 0; i < this.state.excluded_places.length; i ++) {
			const place: any = this.state.excluded_places[i];

			const polygon = new google.maps.Polygon({
		      paths: place?.coords?.map((i: any) => {
	    		return {
	    			lat: parseFloat(i.latitude),
	    			lng: parseFloat(i.longitude)
	    		}
		      })
		    });

		    const center = new google.maps.LatLng(parseFloat(user_address?.latitude || '10.48801'),parseFloat(user_address?.longitude || '-66.87919'));

			const in_polygon = this.checkIfPolygonContains(
				center,
				polygon
			);

			if (in_polygon) {
				Globals.showError("Lo sentimos, la zona indicada en el mapa se encuentra fuera del área del servicio");
				return;
			}
		}

		let discount = null;
		let city = null;
		let municipality = null;

		if (this.state.form.discount_code !== '') {
			const res: any = await ClientQuoteService.client.checkDiscountCode({
				discount_code: this.state.form.discount_code,
				user_id: this.props.user?.owner_id || this.props.user?.id,
				city_id: user_address?.city_id,
				municipality_id: user_address?.municipality_id
			});
			if (res.discount) {
				discount = res.discount;
			}
			if (res.city) {
				city = res.city;
			}
			if (res.municipality) {
				municipality = res.municipality;
			}
		}

		let item: any = { ...this.state.form };
		// @ts-ignore
		item.user_address = JSON.stringify(this.state.user_addresses[this.state.selected_address]);

		// @ts-ignore
		item.latitude = this.state.user_addresses[this.state.selected_address].latitude;
		// @ts-ignore
		item.longitude = this.state.user_addresses[this.state.selected_address].longitude;

		item.area = this.state.form.area ? (this.state.form.area + ' m2') : '-';
		item.journey = this.state.journeys.find((i: any) => i.id == this.state.form.journey_id);
		if (this.state.form.type_id == Constants.QUOTE_TYPES.DEEP.toString()) {
			// @ts-ignore
			item.price = price_per_meter?.price * parseFloat((this.state.form.area < price_per_meter?.minimum) ? price_per_meter?.minimum : this.state.form.area);
			item.original_price = price_per_meter?.price * parseFloat((this.state.form.area < price_per_meter?.minimum) ? price_per_meter?.minimum : this.state.form.area);
		}
		else if (this.state.form.type_id == Constants.QUOTE_TYPES.CUSTOM.toString() || !Globals.isQuoteTypeBase(this.state.form.type_id)) {
			const service_areas_total = service?.service_areas?.filter((i: any) => {
				return (this.state.form.type_id == Constants.QUOTE_TYPES.CUSTOM.toString() && i.type_id == null) || (!Globals.isQuoteTypeBase(this.state.form.type_id) && i.type_id == this.state.form.type_id);
			}).map((item: any) => (item.quantity || 0) * item.price).reduce((a: number, b: number) => a + b,0);

			item.price = service_areas_total;
			item.original_price = service_areas_total;
		}
		else if (this.state.form.type_id == Constants.QUOTE_TYPES.URGENT.toString()) {
			let urgent_price: any = this.state.urgent_prices.find((i: any) => i.until >= parseFloat(this.state.form.area));

			if (!urgent_price && this.state.urgent_prices.length > 0) {
				urgent_price = this.state.urgent_prices[this.state.urgent_prices.length - 1];
			}

			if (urgent_price) {
				item.price = urgent_price?.price;
				item.original_price = urgent_price?.price;
			}
			else {
				item.price = service?.price;
				item.original_price = service?.price;
			}
		}
		else {
			item.price = service?.price;
			item.original_price = service?.price;
		}

		const accessories = this.state.accessories.filter((i: any) => i.quantity > 0);
		if (accessories.length > 0) {
			item.price += accessories.map((i: any) => i.price * i.quantity).reduce((a: number, b: number) => a + b,0);
			item.original_price += accessories.map((i: any) => i.price * i.quantity).reduce((a: number, b: number) => a + b,0);
		}

		item.surcharges = this.state.surcharges;
		item.journey_surcharge = this.state.journey_surcharge;
		item.service = service;
		item.service_id = service?.id;
		item.user = this.props.user;
		item.user_id = this.props.user?.owner_id || this.props.user?.id;
		item.selected_address = this.state.selected_address;
		item.accessories = JSON.stringify(accessories.map((item: any) => {
			return {
				name: item.name,
				price: item.price,
				accessory_id: item.id,
				quantity: item.quantity
			}
		}))
		item.service_areas = JSON.stringify(service?.service_areas?.filter((i: any) => {
			return (this.state.form.type_id == Constants.QUOTE_TYPES.CUSTOM.toString() && i.type_id == null) || (!Globals.isQuoteTypeBase(this.state.form.type_id) && i.type_id == this.state.form.type_id);
		}).filter((item: any) => item.quantity != 0 && item.quantity != null && item.quantity != '').map((item: any) => {
			return {
				name: item.name,
				price: item.price,
				quantity: item.quantity
			}
		}))

		if (item.type_id == Constants.QUOTE_TYPES.URGENT.toString()) {
			item.date = moment().add(1,'day').format('YYYY-MM-DD');

			// @ts-ignore
			while (this.state.holidays.indexOf(item.date) != -1) {
				item.date = moment(item.date).add(1,'day').format('YYYY-MM-DD');
			}
		}

		let address = '';

		const state: any = this.state.states.find((i: any) => i.id == user_address?.state_id);
		const _address = user_address?.address;

		item.multiples_dates = this.state.multiples_dates;
		item.days_selected = this.state.days_selected; 

		item.city = '';
		if (state) {
			if (item.city)
			    item.city += ' - ';
			item.city += state?.name;
		}
		if (city) {
			if (item.city)
			    item.city += ' - ';
			item.city += city?.name;
		}
		if (municipality) {
			if (item.city)
			    item.city += ' - ';
			item.city += municipality?.name;
		}
		if (_address) {
			if (item.city)
			    item.city += ' - ';
			item.city += _address;
		}
		if (user_address.information) {
			if (item.city)
			    item.city += ' - ';
			item.city += user_address.information;
		}
		if (user_address.indications) {
			if (item.city)
			    item.city += ' - ';
			item.city += user_address.indications;
		}

		item.photos = [];
		item.uploaded_photos = 0;

		if (this.state.form.type_id == Constants.QUOTE_TYPES.DEEP.toString()) {
			item.photos = this.state.photos.map((i: any) => i.value);
			item.uploaded_photos = this.state.photos.length;
		}

		if (discount) {
			item.discount = discount;
			item.discount_id = discount?.id;

			item.discount_amount = parseFloat((item.price * (discount.percent / 100)).toFixed(2));
			item.price = item.price - item.discount_amount;

			this.setState({
				discount: discount.percent
			});
		}
		else {
			this.setState({
				discount: null
			});
		}

		let item_to_url = JSON.parse(JSON.stringify(item));
		delete item_to_url.service;
		delete item_to_url.user;	
		delete item_to_url.journey;
		delete item_to_url.discount;

		if (!this.props.user) {
			this.setState({
				visible_login: true
			});
			return;
		}

		this.setState({
			visible_payment: true,
			item,
			item_to_url: new URLSearchParams(item_to_url).toString()
		});
	}

	onCloseView = (submit: boolean = false) => {
		this.setState({
			visible_view: false
		},async () => {
			if (submit) {
				this.setState({
					visible_payment: true
				});
			}
		});
	}

	onClosePayment = (submit: boolean = false) => {
		this.setState({
			visible_payment: false
		},() => {
			if (submit) {
				this.props.history.push({
					pathname: '/client/quotes',
					state: {
						open_confirm: true
					}
				});
			}
		});
	}

	edit = (e: any, item: any, index: number) => {
		e.preventDefault();
		const user_address = this.state.user_addresses[index];
		this.setState({
			active_index: index,
			user_address,
			add_new: true
		},() => {
			setTimeout(() => {
				const element: any = document.getElementById('row-form');
			    if (element) {
			      window.scrollTo({ top: element.offsetTop - 100, behavior: 'smooth' });
			    }
			},100);		
			this.setMap();
			this.getCities();
		});
	}

	delete = (e: any, item: any, index: number) => {
		e.preventDefault();
		const user_addresses = this.state.user_addresses;
		user_addresses.splice(index,1);
		this.setState({
			user_addresses,
			selected_address: null
		},() => this.updateAddresses());
	}

	changeUserAddress = (e: any,callback = () => {}) => {
		this.setState({
			user_address: {
				...this.state.user_address,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	getCities = async () => {
		const res: any = await ProfileService.getCities({
			state_id: this.state.user_address.state_id,
			user_id: this.props.user?.id
		});
		this.setState({
			cities: res.cities,
			municipalities: res.municipalities
		});
	}

	add = () => {
		const {
			state_id,
			city_id,
			municipality_id,
			address,
			information,
			name,
			indications
		} = this.state.user_address;

		if (!state_id || !city_id || !municipality_id || !address || !name || !indications) {
			Globals.showError("Debe ingresar todos los datos para continuar");
			return;
		}

		for (let i = 0; i < this.state.excluded_places.length; i ++) {
			const place: any = this.state.excluded_places[i];

			const polygon = new google.maps.Polygon({
		      paths: place?.coords?.map((i: any) => {
	    		return {
	    			lat: parseFloat(i.latitude),
	    			lng: parseFloat(i.longitude)
	    		}
		      })
		    });

		    const center = new google.maps.LatLng(parseFloat(this.state.user_address?.latitude || '10.48801'),parseFloat(this.state.user_address?.longitude || '-66.87919'));

			const in_polygon = this.checkIfPolygonContains(
				center,
				polygon
			);

			if (in_polygon) {
				Globals.showError("Lo sentimos, la zona indicada en el mapa se encuentra fuera del área del servicio");
				return;
			}
		}

		let user_addresses: any = [...this.state.user_addresses];
		// @ts-ignore
		if (this.state.active_index != null && user_addresses[this.state.active_index]) {
			// @ts-ignore
			user_addresses[this.state.active_index] = this.state.user_address;
		}
		else {
			user_addresses.push(this.state.user_address);
		}
		this.setState({
			user_addresses,
			add_new: false,
			user_address: INITIAL_STATE,
			active_index: null,
			selected_address: user_addresses.length - 1
		},() => this.updateAddresses());
	}

	updateAddresses = async () => {
		if (this.props.user) {
			await ClientProfileService.client.updateAddresses({
				user_id: this.props.user?.owner_id || this.props.user?.id,
				user_addresses: JSON.stringify(this.state.user_addresses),
				withoutLoading: true
			});
		}
	}

	calculateSurchargesOLD = async () => {
		let surcharges = 0;
		const journey: any = this.state.journeys.find((i: any) => i.id == this.state.form.journey_id);
		let journey_surcharge = journey?.surcharge || 0;

		if (this.state.multiples_dates) {
			journey_surcharge *= this.state.days_selected.length;
		}

		if (this.state.multiples_dates) {
			const total_accessories = this.state.accessories.filter((i: any) => i.quantity > 0).map((i: any) => i.quantity).reduce((a: number, b: number) => a + b,0) * this.state.special_day_price_accessories;
			let quantity = 0;
			for (let i = 0; i < this.state.days_selected.length; i++) {
				const index = this.state.special_days.map((i: any) => i.day).indexOf(this.state.days_selected[i]);
				if (index != -1) {
					quantity++;
					// @ts-ignore
					surcharges += this.state.special_days[index].price || this.state.special_day_price;
				}
			}
			surcharges += (total_accessories * quantity);
		}
		else {
			const index = this.state.special_days.map((i: any) => i.day).indexOf(this.state.form.date);
			if (index != -1) {
				// @ts-ignore
				surcharges = this.state.special_days[index].price || this.state.special_day_price;
				console.log('surcharges', surcharges);
				surcharges += this.state.accessories.filter((i: any) => i.quantity > 0).map((i: any) => i.quantity).reduce((a: number, b: number) => a + b,0) * this.state.special_day_price_accessories;
				console.log('surcharges', surcharges);
			}
			else {
				surcharges = 0;
			}
		}

		this.setState({
			surcharges,
			journey_surcharge
		});
	}

	calculateSurcharges = async () => {
		// 1. Aseguramos el tipado numérico desde la inicialización
		let surcharges: number = 0;

		const journey: any = this.state.journeys.find((i: any) => i.id == this.state.form.journey_id);
		let journey_surcharge: number = Number(journey?.surcharge) || 0;

		const isMultipleDates = this.state.multiples_dates;
		const daysSelectedCount = this.state.days_selected?.length || 0;

		if (isMultipleDates) {
			journey_surcharge *= daysSelectedCount;
		}

		// Convertimos la cantidad explícitamente a Number para evitar concatenaciones
		const total_accessories_quantity = this.state.accessories
			.filter((i: any) => Number(i.quantity) > 0)
			.reduce((total: number, current: any) => total + Number(current.quantity), 0);

		const accessories_cost_per_day = total_accessories_quantity * Number(this.state.special_day_price_accessories);

		// 3. Evaluamos recargos por días feriados
		if (isMultipleDates) {
			let special_days_matched = 0;

			for (const day of this.state.days_selected) {
				const specialDay: any = this.state.special_days.find((i: any) => i.day === day);

				if (specialDay) {
					special_days_matched++;
					surcharges += Number(specialDay.price) || Number(this.state.special_day_price);
				}
			}
			surcharges += (accessories_cost_per_day * special_days_matched);

		} else {
			const specialDay: any = this.state.special_days.find((i: any) => i.day === this.state.form.date);

			if (specialDay) {
				const base_surcharge = Number(specialDay.price) || Number(this.state.special_day_price);
				surcharges = base_surcharge + accessories_cost_per_day;
			}
		}

		// 4. Actualizamos el estado
		this.setState({
			surcharges,
			journey_surcharge
		});
	}

	onCloseCalendar = () => {
		this.setState({
			visible_calendar: false
		});
	}

	addPhoto = (photo: any) => {
		if (this.state.photos.length < MAX_PHOTOS) {
			let photos: any = [...this.state.photos];
			photos.push(photo);
			this.setState({
				photos
			});
		}
	}

	onCloseSuccess = (submit = false) => {
		this.setState({
			visible_success: false
		},() => {
			if (submit) {
				window.location.reload();
			}
			else {
				this.props.history.push({
					pathname: '/client/quotes'
				});
			}
		});
	}

	onCloseLogin = (withLoad: boolean = false) => {
		this.setState({
			visible_login: false
		},() => {
			this.verifyValidate();
			if (withLoad) {
				this.load(true);
			}
		});
	}

	onCloseRegister = (withoutLogin: boolean = false) => {
		this.setState({
			visible_register: false,
			visible_login: !withoutLogin
		},() => {
			this.verifyValidate();
		});
	}

	onCloseReset = () => {
		this.setState({
			visible_reset: false,
			visible_login: true
		});
	}

	onCloseVerifyAccount = (withLogin: boolean = false) => {
		this.setState({
			visible_verify_account: false,
			visible_login: withLogin
		},() => {
			this.verifyValidate();
			if (withLogin) {
				this.load(true);
			}
		});
	}

	// Función para manejar la lógica de replicación de servicio
	handleReplicateLastService = async () => {
		const { user } = this.props;

		Globals.setLoading();

		try {
			const response: any = await ClientQuoteService.client.getLastFinished({ user_id: user.id });

			if (response.success && response.quote) {
				const lastQuote = response.quote;

				const res: any = await ClientQuoteService.client.viewService({
					service_id: lastQuote.service_id,
					user_id: this.props.user?.owner_id || this.props.user?.id,
					withoutLoading: true
				});

				const serviceData = res.service
					? res.service
					: (res.services && res.services.length > 0 ? res.services[0] : null);

				if (!serviceData || serviceData.status == Constants.SERVICE_STATUS.INACTIVE) {
					Globals.quitLoading();
					Globals.showError("El servicio realizado anteriormente ya no está disponible.");
					return;
				}

				// --- Hidratación de precios (Data Fresca) ---
				if (Globals.checkIfCorporate(this.props.user) || (this.props.user?.owner_id != null && this.props.user?.user_type_id == Constants.USER_TYPES.SUBUSER)) {
					if (serviceData) serviceData.price = serviceData.price_corporate || serviceData.price;
					if (res.urgent_prices) res.urgent_prices.forEach((item: any) => { if (item.price_corporate) item.price = item.price_corporate; });
					if (res.accessories) res.accessories.forEach((item: any) => { if (item.price_corporate) item.price = item.price_corporate; });
					if (res.price_per_meter && res.price_per_meter.price_corporate) res.price_per_meter.price = res.price_per_meter.price_corporate;
				}

				// --- Encontrar la dirección ---
				const availableAddresses = res.user_addresses || [];
				let selectedAddressIndex = 0;
				if (availableAddresses.length > 0) {
					const foundIndex = availableAddresses.findIndex((addr: any) => {
						return (
							addr.state_id == lastQuote.state_id &&
							addr.city_id == lastQuote.city_id &&
							addr.municipality_id == lastQuote.municipality_id &&
							String(addr.latitude) == String(lastQuote.latitude) &&
							String(addr.longitude) == String(lastQuote.longitude)
						);
					});
					if (foundIndex !== -1) selectedAddressIndex = foundIndex;
				}

				// --- Mapeo de Accesorios ---
				const availableAccessories = res.accessories || [];
				const updatedAccessories = availableAccessories.map((acc: any) => {
					const found = lastQuote.quote_accessories?.find((oldAcc: any) => oldAcc.accessory_id === acc.id);
					return { ...acc, quantity: found ? found.quantity : 0 };
				});

				// --- Mapeo de Áreas de Servicio ---
				let oldAreas: any = [];
				if (lastQuote.quote_areas && lastQuote.quote_areas.length > 0) {
					oldAreas = lastQuote.quote_areas;
				}
				console.log('oldAreas', oldAreas);

				const freshServiceAreas = serviceData.service_areas || [];
				let parsedServiceAreas = [];

				if (freshServiceAreas.length > 0) {
					// Mapeamos las áreas actuales y les inyectamos el "quantity" si coinciden con la orden pasada
					parsedServiceAreas = freshServiceAreas.map((freshArea: any) => {
						const foundOldArea = oldAreas.find((old: any) =>
							old.name && freshArea.name &&
							old.name.trim().toLowerCase() === freshArea.name.trim().toLowerCase()
						);

						return {
							...freshArea,
							quantity: foundOldArea ? foundOldArea.quantity : 0
						};
					});
				} else {
					parsedServiceAreas = freshServiceAreas;
				}
				serviceData.service_areas = parsedServiceAreas;
				console.log('parsedServiceAreas', parsedServiceAreas);

				// --- MAPEO DE FOTOS (El requerimiento clave) ---
				let previousPhotos = [];
				if (lastQuote.images && lastQuote.images.length > 0) {
					previousPhotos = lastQuote.images.map((img: any) => ({
						id: img.id,
						url: Constants.BASE_STORAGE + img.file, // Ajusta a tu variable de entorno/ruta pública
						file_path: img.file,
						is_existing: true // Flag vital para no re-subir el archivo como binario
					}));
				} else {
					// Fallback por si la cita vieja no tuvo fotos pero tiene slots
					const uploadedCount = lastQuote.uploaded_photos || 0;
					previousPhotos = Array.from({ length: uploadedCount }, () => ({}));
				}

				let formattedArea = '';
				if (lastQuote.area && lastQuote.area !== '-') {
					// La regex /[\d.]+/ extrae la primera coincidencia de números y puntos (ej: "75 m2" -> "75")
					const match = String(lastQuote.area).match(/[\d.]+/);
					formattedArea = match ? match[0] : '';
				}

				console.log('serviceData', serviceData);

				this.setState({
					service: serviceData,
					holidays: res.holidays || [],
					user_addresses: [...res.user_addresses, ...this.state.user_addresses.filter((item: any) => item.id == null)],
					states: res.states || [],
					quote_types: res.quote_types || [],
					price_per_meter: res.price_per_meter,
					urgent_prices: res.urgent_prices || [],
					urgent_available: res.urgent_available,
					special_days: res.special_days || [],
					special_day_price: res.special_day_price || 0,
					special_day_price_accessories: res.special_day_price_accessories || 0,
					excluded_places: res.excluded_places || [],
					quote_limit: res.quote_limit || 4,
					services: res.services || [],
					default_journey: res.default_journey,
					conversion: res.conversion || 0,
					journeys: res.journeys || [],

					accessories: updatedAccessories,
					selected_address: selectedAddressIndex,

					// --- Variables dinámicas inyectadas ---
					service_areas: parsedServiceAreas,
					photos: previousPhotos,
					uploaded_photos: previousPhotos.length,

					item: {
						...(this.state.item || {}),
						service_id: lastQuote.service_id,
						recurring_service_id: lastQuote.recurring_service_id,
						state_id: lastQuote.state_id,
						city_id: lastQuote.city_id,
						municipality_id: lastQuote.municipality_id,
						indications: lastQuote.indications,
						information: lastQuote.information,
						latitude: lastQuote.latitude,
						longitude: lastQuote.longitude,
						journey_id: lastQuote.journey_id,
						description: lastQuote.comments || lastQuote.description,
						id: null,
						date: '', // Como solicitaste, no se carga fecha
						time: '',
						payment_method_id: null, // Ni método de pago
						payment_photo: null,
						status_id: 1,
						services: lastQuote.services || [],
					},
					form: {
						...(this.state.form || {}),
						type_id: lastQuote.type_id,
						journey_id: lastQuote.journey_id,
						area: formattedArea,
						area_id: lastQuote.area_id || '',
						comments: lastQuote.comments || ''
					}
				}, () => {
					Globals.quitLoading();
					if (this.calculateSurcharges) this.calculateSurcharges();
					Globals.showSuccess("Datos cargados correctamente. Recuerda seleccionar la fecha del servicio.");
				});

			} else {
				Globals.quitLoading();
				Globals.showError("No se encontró un servicio anterior para replicar.");
			}
		} catch (error) {
			Globals.quitLoading();
			console.error("Error replicando servicio:", error);
			Globals.showError("Ocurrió un error al cargar los datos.");
		}
	}
	
	render() {
		const surcharges: any = this.state.surcharges;
		const journey_surcharge: any = this.state.journey_surcharge;
		const service: any = this.state.service;
		const service_areas_total: number = service?.service_areas?.filter((i: any) => {
			return (this.state.form.type_id == Constants.QUOTE_TYPES.CUSTOM.toString() && i.type_id == null) || (!Globals.isQuoteTypeBase(this.state.form.type_id) && i.type_id == this.state.form.type_id);
		}).map((item: any) => (item.quantity || 0) * item.price).reduce((a: number, b: number) => a + b,0);
		const { error_map, visible_view, visible_payment, quotes, add_new, items_marquee, visible_calendar, conversion, discount } = this.state;
		const price_per_meter: any = this.state.price_per_meter;
		let urgent_price: any = this.state.urgent_prices.find((i: any) => i.until >= parseFloat(this.state.form.area));
		// @ts-ignore
		const area_with_price = this.state.service?.service_areas?.filter((i: any) => {
			return (this.state.form.type_id == Constants.QUOTE_TYPES.CUSTOM.toString() && i.type_id == null) || (!Globals.isQuoteTypeBase(this.state.form.type_id) && i.type_id == this.state.form.type_id);
		}).find((item: any) => item.quantity != 0 && item.quantity != '' && item.quantity != null);

		if (!urgent_price && this.state.urgent_prices.length > 0) {
			urgent_price = this.state.urgent_prices[this.state.urgent_prices.length - 1];
		}

		const quote_type: any = this.state.quote_types.find((i: any) => i.id == this.state.form.type_id);
		const holidays: any = this.state.holidays || [];
		const is_urgent = this.state.form.type_id == Constants.QUOTE_TYPES.URGENT.toString();
		const journeys: any = this.state.journeys.filter((i: any) => {
			const service_journey = service?.service_journeys?.find((item: any) => item.journey_id == i.id);

			if (is_urgent || this.state.multiples_dates) {
				return true;
			}
			else if (i.quantity >= service_journey?.quantity) {
				return false;
			}	

			return true;
		});

		const quantity_of_days = this.state.multiples_dates ? this.state.days_selected.length : 1;
		const total_accessories = this.state.accessories.filter((i: any) => i.quantity > 0).map((i: any) => i.price * i.quantity).reduce((a: number, b: number) => a + b,0) * quantity_of_days;

		let base_price = 0;

		if (this.state.form.type_id == Constants.QUOTE_TYPES.DEEP.toString()) {
			base_price = (((price_per_meter?.price * parseFloat((this.state.form.area < price_per_meter?.minimum) ? price_per_meter?.minimum : this.state.form.area))) * quantity_of_days);
		}
		else if (this.state.form.type_id == Constants.QUOTE_TYPES.CUSTOM.toString() || !Globals.isQuoteTypeBase(this.state.form.type_id)) {
			base_price = service_areas_total;
		}
		else if (this.state.form.type_id == Constants.QUOTE_TYPES.URGENT.toString()) {
			base_price = ((urgent_price?.price) * quantity_of_days);
		}
		else {
			base_price = (((service?.price)) * quantity_of_days);
		}

		if (discount != null) {
	 		const discount_amount = parseFloat((base_price * (discount / 100)).toFixed(2));
			base_price = base_price - discount_amount;
		}		

		// @ts-ignore
		const user_address: any = this.state.user_addresses[this.state.selected_address];

		let address = '';

		const state: any = this.state.states.find((i: any) => i.id == user_address?.state_id);
		const _address = user_address?.address;

		let city = '';
		if (state) {
			if (city)
			    city += ' - ';
			city += state?.name;
		}
		if (_address) {
			if (city)
			    city += ' - ';
			city += _address;
		}
		if (user_address?.information) {
			if (city)
			    city += ' - ';
			city += user_address?.information;
		}
		if (user_address?.indications) {
			if (city)
			    city += ' - ';
			city += user_address?.indications;
		}

		const is_corporate = Globals.checkIfCorporate(this.props.user) || (this.props.user?.owner_id != null && this.props.user?.user_type_id == Constants.USER_TYPES.SUBUSER);

		const TotalContainer = (props: any) => {
			return (
				<div className="row-price-relative">
					<div className="row-gray-price">
						<h5 className="header-price">Detalle de reserva</h5>

						<div className="row">
							<div className="col-12">
								<div className="container-total-icon">
									<img src={ CalendarIcon } />
									{
										this.state.multiples_dates ? (
											<>
												{
							    					this.state.days_selected.map((item: any, index: number) => {
							    						return (
							    							<div className="item-date-multiple">
							    								<p>{ moment(item).format('DD-MM-YYYY') }</p>
							    							</div>
							    						)
							    					})
												}
											</>
										) : (
											<p>{ moment(this.state.form.date).format('DD [de] MMMM YYYY') }</p>
										)
									}
								</div>
							</div>

							{
								user_address != null && (
									<div className="col-12">
										<div className="container-total-icon">
											<img src={ LocationIcon } />
											<p>{ city }</p>
										</div>
									</div>
								)
							}

							{
								(this.state.form.area_id || this.state.form.area || this.state.form.type_id == Constants.QUOTE_TYPES.NORMAL.toString() || ((this.state.form.type_id == Constants.QUOTE_TYPES.CUSTOM.toString() || !Globals.isQuoteTypeBase(this.state.form.type_id)) && area_with_price != null)) ? (
									<>
										<div className="totals-gray">
											<div className="col-12">
												{
													(this.state.form.type_id == Constants.QUOTE_TYPES.CUSTOM.toString() || !Globals.isQuoteTypeBase(this.state.form.type_id)) ? (
														<>
															{
																service?.service_areas?.filter((i: any) => {
																	return (this.state.form.type_id == Constants.QUOTE_TYPES.CUSTOM.toString() && i.type_id == null) || (!Globals.isQuoteTypeBase(this.state.form.type_id) && i.type_id == this.state.form.type_id);
																}).filter((item: any) => item.quantity != null && item.quantity != 0 && item.quantity != '').map((item: any) => {
																	return (
																		<div className="row">
																			<div className="col-md-6">
																				<p>{ item.name } x{ item.quantity }</p>
																			</div>
																			<div className="col-md-6 text-right">
																				<p className="bold">{ Globals.formatMiles(item.price * item.quantity,true,Constants.CURRENCIES_SYMBOL.BOLIVAR,conversion || 0) }</p>
																			</div>
																		</div>
																	)
																})
															}
														</>
													) : (
														<div className="row">
															<div className="col-md-6">
																<p>{ quote_type?.name }</p>
															</div>
															<div className="col-md-6 text-right">
																<p className="bold">{ Globals.formatMiles(base_price,true,Constants.CURRENCIES_SYMBOL.BOLIVAR,conversion || 0) }</p>
															</div>
														</div>
													)
												}
												{
													this.state.accessories.filter((i: any) => i.quantity > 0).length > 0 && (
														<>
															<div className="row">
																<div className="col-md-6">
																	<p className="title-accessories">Servicios Adicionales</p>
																</div>
															</div>
															{
																this.state.accessories.filter((i: any) => i.quantity > 0).map((item: any) => {
																	return (
																		<div className="row">
																			<div className="col-md-6">
																				<p className="gray">{ item.name }</p>
																			</div>
																			<div className="col-md-6 text-right">
																				<p className="bold">{ Globals.formatMiles(item.price * item.quantity * quantity_of_days,true,Constants.CURRENCIES_SYMBOL.BOLIVAR,conversion || 0) }</p>
																			</div>
																		</div>
																	)
																})
															}
														</>
													)
												}
												{
													surcharges > 0 && (
														<div className="row">
															<div className="col-md-6">
																<p>{ this.props.surcharge_title }</p>
															</div>
															<div className="col-md-6 text-right">
																<p className="bold">{ Globals.formatMiles(surcharges,true,Constants.CURRENCIES_SYMBOL.BOLIVAR,conversion || 0) }</p>
															</div>
														</div>
													)
												}
												{
													journey_surcharge > 0 && (
														<div className="row">
															<div className="col-md-6">
																<p>Recargo por Jornada</p>
															</div>
															<div className="col-md-6 text-right">
																<p className="bold">{ Globals.formatMiles(journey_surcharge,true,Constants.CURRENCIES_SYMBOL.BOLIVAR,conversion || 0) }</p>
															</div>
														</div>
													)
												}
												{
													this.state.discount != null && (
														<div className="row">
															<div className="col-md-6">
																<p>Descuento</p>
															</div>
															<div className="col-md-6 text-right">
																<p className="bold">{ Globals.formatMiles(this.state.discount,true,'') } %</p>
															</div>
														</div>
													)
												}
											</div>
										</div>

										<div className="row row-subtotal">
											<div className="col-md-6">
												<p className="gray">Sub-Total</p>
											</div>
											<div className="col-md-6 text-right">
												<p className="bold gray">{ Globals.formatMiles(base_price + total_accessories + surcharges + journey_surcharge,true,Constants.CURRENCIES_SYMBOL.BOLIVAR,conversion || 0) }</p>
											</div>
										</div>

										<div className="row row-total">
											<div className="col-md-6">
												<p>Total</p>
											</div>
											<div className="col-md-6 text-right">
												<p>{ Globals.formatMiles(base_price + total_accessories + surcharges + journey_surcharge,true,Constants.CURRENCIES_SYMBOL.BOLIVAR,conversion || 0) }</p>
											</div>
										</div>
									</>
								) : (
									<div className="col-12">
										{
											(this.state.form.type_id == Constants.QUOTE_TYPES.CUSTOM.toString() || !Globals.isQuoteTypeBase(this.state.form.type_id)) ? (
												<p className="no-total">Debe indicar la cantidad de cada área a limpiar</p>
											) : (
												<p className="no-total">Debe indicar la cantidad para continuar</p>
											)
										}
									</div>
								)
							}
							{
								!props.withoutSubmit && (
									<>
										<div className="col-md-12 text-center">
											<button className="btn btn-next" onClick={ () => this.submit() }>
												Pagar
											</button>
										</div>
										{
											this.props.user && (
												<div className="col-md-12 text-center">
													<button className="btn btn-return" onClick={ () => this.back() }>
														Volver
													</button>
												</div>
											)
										}
									</>
								)
							}
						</div>
					</div>
				</div>
			)
		}

		const Marquee = () => {
			return (
				<div className="container-marquee">
					{
						items_marquee.map((item: any) => {
							return (
								<img src={ item } />
							)
						})
					}
				</div>
			)
		}

		return (
			<div id="client-request-quotes">
				{/*<BackComponent />*/}

				<Modal
		          className="modal-quotes-view"
		          visible={ visible_view }
		          title="Orden de Servicio"
		          centered
		          onClose={ () => this.onCloseView() }
		        >
		        	<ModalConfirm
		        		onClose={ (submit: boolean = false) => this.onCloseView(submit) }
		        		item={ this.state.item }
		        		conversion={ this.state.conversion }
		        	/>
		      	</Modal>

		      	<Modal
		          className="modal-quotes-payment"
		          visible={ visible_payment }
		          title=""
		          centered
		          animation={ false }
		          onClose={ () => this.onClosePayment() }
		        >	
		        	{/*
		        	// @ts-ignore */}
		        	<ModalPayment
		        		onClose={ (submit: boolean = false) => {
		        			if (submit) {
		        				this.setState({
		        					visible_success: true,
		        					visible_payment: false
		        				});
		        			}
		        			else {
		        				this.onClosePayment(submit);
		        			}
		        		} }
		        		item={ this.state.item }
		        		item_to_url={ this.state.item_to_url }
		        		TotalContainer={ TotalContainer }
		        		Marquee={ Marquee }
		        		submit={ (params: any = {}) => this.submit(params) }
		        	/>
		      	</Modal>

		      	<Modal
		          className="modal-success-quote"
		          visible={ this.state.visible_success }
		          title=""
		          centered
		          onClose={ () => this.onCloseSuccess() }
		        >
		        	<ModalSuccess
		        		onClose={ (submit: boolean = false) => this.onCloseSuccess(submit) }
		        	/>
		      	</Modal>

		      	<Modal
		          className="modal-quotes-login"
		          visible={ this.state.visible_login }
		          title=""
		          centered
		          onClose={ () => this.onCloseLogin() }
		        >
		        	{/*
		        	// @ts-ignore */}
		        	<ModalLogin
		        		openRegister={ () => {
		        			this.setState({
		        				visible_register: true,
		        				visible_login: false
		        			});
		        		} }
		        		openReset={ () => {
		        			this.setState({
		        				visible_reset: true,
		        				visible_login: false
		        			});
		        		} }
		        		history={ this.props.history }
		        		onClose={ (withLoad: boolean = false) => this.onCloseLogin(withLoad) }
		        	/>
		      	</Modal>

		      	<Modal
		          className="modal-quotes-register"
		          visible={ this.state.visible_register }
		          title=""
		          centered
		          onClose={ () => this.onCloseRegister() }
		        >
		        	{/*
		        	// @ts-ignore */}
		        	<ModalRegister
		        		onClose={ (withoutLogin: boolean = false) => this.onCloseRegister(withoutLogin) }
		        	/>
		      	</Modal>

		      	<Modal
		          className="modal-quotes-verify-account"
		          visible={ this.state.visible_verify_account }
		          title=""
		          centered
		          withoutClose={ true }
		          onClose={ () => this.onCloseVerifyAccount() }
		        >
		        	{/*
		        	// @ts-ignore */}
		        	<ModalVerifyAccount
		        		onClose={ (withLogin: boolean = false) => this.onCloseVerifyAccount(withLogin) }
		        	/>
		      	</Modal>

		      	<Modal
		          className="modal-quotes-reset"
		          visible={ this.state.visible_reset }
		          title=""
		          centered
		          onClose={ () => this.onCloseReset() }
		        >
		        	<ModalReset
		        		onClose={ () => this.onCloseReset() }
		        	/>
		      	</Modal>

		      	<Modal
		          className="modal-client-calendar"
		          visible={ visible_calendar }
		          title=""
		          centered
		          onClose={ () => this.onCloseCalendar() }
		        >	
		        	<div id="modal-client-calendar">
						<div className="container-calendar">
							<div className="row row-calendar">
								<div className="col-md-5">
									<div className="container-arrow">
										<Select
											withoutPlaceholder={ true }
											name="month"
											onChange={ (e: any) => {
												this.setState({
													currentMonth: e.target.value
												},() => {
													this.calendar?.getApi().gotoDate(moment(this.state.currentYear + '-' + this.state.currentMonth,'YYYY-MMMM').format('YYYY-MM-DD'));
													this.loadQuotesMonth();
												});
											} }
											value={ this.state.currentMonth }
											options={ this.state.months || [] } />
									</div>
								</div>
								<div className="col-md-5">
									<div className="container-arrow">
										<button className="btn btn-arrow" onClick={ () => {
											this.calendar.getApi().prevYear();
											this.updateDate();
										} }>
											<img src={ ArrowLeftBlack } />
										</button>
										<h4>{ this.state.currentYear }</h4>
										<button className="btn btn-arrow" onClick={ () => {
											this.calendar.getApi().nextYear();
											this.updateDate();
										} }>
											<img src={ ArrowRightBlack } />
										</button>
									</div>
								</div>
								<div className="col-md-2 text-right">
									<a href="#" className="close-calendar" onClick={ (e: any) => {
										e.preventDefault();
										this.setState({
											visible_calendar: false
										});
									} }>
										<img src={ CloseIcon } />
									</a>
								</div>
							</div>
							<FullCalendar
								ref={ ref => this.calendar = ref }
						        plugins={[ dayGridPlugin ]}
						        initialView="dayGridMonth"
						        locale="es"
						        dayHeaderContent={ (args: any) => {
						        	return (
						        		<button className="btn day-container day-header">
											<p>{ args.text.substring(0,1) }</p>
					        			</button>
						        	)
						        } }
					        	dayCellContent={ (info) => {
					        		const date = moment(info.date).format('YYYY-MM-DD');
					        		const journeys: any = this.state.journeys.filter((i: any) => {
										const service_journey = service?.service_journeys?.find((item: any) => item.journey_id == i.id);

										if (quotes.filter((item: any) => item.journey_id == i.id && moment(item.date).format('YYYY-MM-DD') == date).length >= service_journey?.quantity) {
											return false;
										}	

										return true;
									});

					        		return (
					        			<button disabled={ 
					        				date == moment().format('YYYY-MM-DD') || 
					        				date == moment().add(1,'day').format('YYYY-MM-DD') || 
					        				date < moment().format('YYYY-MM-DD') || 
					        				date > moment().add(6,'months').format('YYYY-MM-DD') || 
					        				holidays.indexOf(date) != -1
					        			} 
					        			// @ts-ignore
					        			className={ `btn day-container ${ (this.state.form.date == date || this.state.days_selected.indexOf(date) != -1) ? 'active' : '' } ${ (holidays.indexOf(date) != -1) ? 'holiday' : '' }` } 
					        			onClick={ () => this.setState({
					        				form: {
					        					...this.state.form,
					        					date
					        				}
					        			},async () => {
					        				if (this.state.multiples_dates) {
					        					let days_selected = [...this.state.days_selected];
					        					const date: any = this.state.form.date;
					        					// @ts-ignore
					        					if (days_selected.indexOf(date) == -1) {
					        						if (days_selected.length >= this.state.quote_limit) {
						        						Globals.showError(`Solo puede seleccionar ${ this.state.quote_limit } fechas como máximo`);
						        						this.setState({
						        							form: {
						        								...this.state.form,
						        								date: days_selected[days_selected.length - 1]
						        							}
						        						});
						        						return;
						        					}
					        						// @ts-ignore
					        						days_selected.push(date);
					        					}
					        					else {
					        						// @ts-ignore
					        						days_selected.splice(days_selected.indexOf(date),1);
					        					}											        					
					        					await this.setState({
					        						days_selected,
					        						form: {
					        							...this.state.form,
					        							date: ''
					        						}
					        					});
					        				}
					        				else {
					        					this.loadJourneys();
					        				}

					        				this.calculateSurcharges();
					        			}) }>
											<p>{ moment(info.date).format('D') }</p>
					        			</button>
					        		)
					        	} }
						        headerToolbar={{
						        	left: '',
						        	center: '',
						        	right:  ''
						        }}
						    />

						    <div className="row row-colors">
						    	<div className="col-md-4">
						    		<div className="item-color">
						    			<div>
						    				<div className="container-red"></div>
						    			</div>
							    		<p>No disponible</p>
						    		</div>
						    	</div>
						    	<div className="col-md-4">
						    		<div className="item-color">
						    			<div>
						    				<div className="container-green"></div>
						    			</div>
							    		<p>Disponible</p>
							    	</div>
						    	</div>
						    	<div className="col-md-4">
						    		<div className="item-color">
						    			<div>
						    				<div className="container-blue"></div>
						    			</div>
							    		<p>Seleccionado</p>
							    	</div>
						    	</div>
						    </div>

						    {
						    	this.state.quote_limit > 1 && (
						    		<div className="text-center">
										<div className="container-check-dates" onClick={ () => {
									    	this.setState({
									    		multiples_dates: !this.state.multiples_dates,
									    		days_selected: this.state.multiples_dates ? [] : [this.state.form.date],
									    		discount: null,
									    		form: {
									    			...this.state.form,
									    			discount_code: ''
									    		}
									    	},() => {
									    		if (!this.state.multiples_dates) {
									    			this.setState({
									    				form: {
									    					...this.state.form,
									    					date: moment().add(2,'days').format('YYYY-MM-DD')
									    				}
									    			},() => this.checkInitialDate());
									    		}
									    	});
									    } }>
									    	<div className="container-check-active">
												{ this.state.multiples_dates && <img src={ CheckGreenIcon } /> }
											</div>
											Seleccionar varias fechas
									    </div>
									</div>
						    	)
						    }

						    {
						    	this.state.days_selected.length > 0 && (
						    		<div style={{ paddingLeft: '10px', paddingRight: '10px' }}>
						    			{
									    	this.state.days_selected.map((item: any, index: number) => {
									    		return (
									    			<div className="item-date">
									    				<p>{ moment(item).format('DD-MM-YYYY') }</p>
									    				<img src={ CloseIcon } onClick={ () => {
									    					let days_selected = [...this.state.days_selected];
									    					days_selected.splice(index,1);
									    					this.setState({
									    						days_selected
									    					});
									    				} } />
									    			</div>
									    		)
									    	})
									    }
						    		</div>
						    	)
						    }

						    <div className="text-center">
							    <button className="btn btn-finish-calendar" onClick={ () => this.onCloseCalendar() }>
									Aceptar
								</button>
							</div>
						</div>
					</div>
		      	</Modal>

				<div className="container-padding-quote">
					<>
						<Header
							withLayout={ true }
							useSocials={ true }
							onLogin={ () => {
								this.setState({
									visible_login: true
								});
							} }
						/>

						<div className="row">
							<div className="col-lg-8">
								{/* Sección Repetir Servicio (Solo visible si hay usuario) */}
								{this.props.user && (
									<div className="row mb-4">
										<div className="col-12">
											<div className="card border-primary mb-3" style={{ borderRadius: '15px' }}>
												<div className="card-body d-flex justify-content-between align-items-center p-3">
													<div className="pr-2">
														<h5 className="mb-1 text-primary" style={{ fontSize: '1rem', fontWeight: 'bold' }}>
															<i className="fa fa-history mr-2"></i> ¿Repetir servicio anterior?
														</h5>
														<p className="mb-0 small text-muted">
															Carga automáticamente la dirección y detalles de tu último servicio finalizado.
														</p>
													</div>
													<button
														type="button"
														className="btn btn-replicate"
														onClick={this.handleReplicateLastService}
														style={{ whiteSpace: 'nowrap' }} // Para evitar que el texto se parta feo
													>
														Cargar datos
													</button>
												</div>
											</div>
										</div>
									</div>
								)}

								<div className="row row-services">
									{
										this.state.services.map((item: any) => {
											return (
												<div className="col-md-3">
													<button className={ `btn btn-service ${ item.id == service?.id ? 'active' : '' }` } onClick={ () => {
														this.setState({
															service: item,
															service_id: item?.id
														},() => {
															this.load();
														});
													} }>
														<img src={ Constants.BASE_STORAGE + item.photo } />
														<p>{ item.name }</p>
													</button>
												</div>
											)
										})
									}
									<div className="col-md-3">
										<a href={ SplendorURL } target="_blank">
											<button className="btn btn-service">
												<img src={ SprayImage } />
												<p>Productos Splendor</p>
											</button>
										</a>
									</div>
									<div className="col-md-3">
										{
											this.state.form.type_id != Constants.QUOTE_TYPES.URGENT.toString() && (
												<div className="container-date">
													<p className="label">Fecha</p>
													<button className="btn" onClick={ () => {
														this.setState({
															visible_calendar: true
														});
													} }>
														<p>{ this.state.days_selected.length > 0 ? this.state.days_selected.map(i => moment(i).format('DD/MM/YYYY')).join(', ') : this.state.form.date ? moment(this.state.form.date).format('DD/MM/YYYY') : 'Seleccionar' }</p>
													</button>
												</div>
											)
										}
									</div>
								</div>

								<div className="addresses">
									<div className="row">
										<div className="col-md-3">
											<div className="title-address">
												<img src={ LocationIcon } />
												<p>Dirección</p>
											</div>
										</div>
										<div className="col-md-9 text-right">
											<a href="#" className="add-address" onClick={ (e: any) => {
												e.preventDefault();
												this.setState({
													add_new: true,
													active_index: null,
													user_address: INITIAL_STATE
												},() => {
													setTimeout(() => {
														const element: any = document.getElementById('row-form');
													    if (element) {
													      window.scrollTo({ top: element.offsetTop - 100, behavior: 'smooth' });
													    }
													},100);
													this.setMap();
												});
											} }>
												<img src={ AddWhiteIcon } />
												Añadir nueva dirección
											</a>
											{
												this.props.user == null && (
													<a href="#" className="link-login" onClick={ (e: any) => {
														e.preventDefault();
														this.setState({
															visible_login: true
														});
													} }>
														¿Estas registrado? Presiona aquí
													</a>
												)
											}
										</div>
									</div>

									{
										this.state.user_addresses.length > 0 && (
											<Table data={ this.state.user_addresses.length } header={ [] }>
												{ this.state.user_addresses.map((i: any,index: number) => {
													return (
														<tr key={ index } className={ this.state.selected_address == index ? 'active' : '' }>
															<td style={{ width: '100%' }}>
																<table className="table-inside">
																	<tr className={ this.state.selected_address == index ? 'active' : '' }>
																		<td style={{ width: '10%', whiteSpace: 'nowrap' }}>
																			<a className="link-icon" href="#" onClick={ (e: any) => this.edit(e,i,index) }>
																				<img src={ EditIcon } />
																			</a>
																			<a className="link-icon" href="#" onClick={ (e: any) => this.delete(e,i,index) }>
																				<img src={ TrashIcon } />
																			</a>
																		</td>
																		<td className="address" style={{ width: '40%' }}>{ i.address }</td>
																		<td className="name" style={{ width: '40%' }}>{ i.name }</td>
																		<td style={{ textAlign: 'right', width: '10%' }}>
																			<div className={ `check ${ this.state.selected_address == index ? 'active' : '' }` } onClick={ (e: any) => {
																				e.preventDefault();
																				if (index == this.state.selected_address) {
																					this.setState({
																						selected_address: null
																					});
																				}
																				else {
																					this.setState({
																						selected_address: index
																					});
																				}

																				this.props.dispatch({
																					type: 'SET_DEFAULT_ADDRESS',
																					payload: i.id
																				});
																			} }>
																				<img src={ CheckWhiteIcon } />
																			</div>
																		</td>
																	</tr>
																</table>
																<p className="address-responsive">{ i.address }</p>
															</td>
														</tr>
													)
												}) }
											</Table>
										)
									}

									{
										this.state.user_addresses.length == 0 && !add_new && (
											<p className="no-addresses">No se han agregado direcciones</p>
										)
									}

									{
										add_new && (
											<React.Fragment>
												<div className="row" id="row-form" style={{ marginTop: '20px' }}>
													<div className="col-md-6">
														<Select
															label="Estado"
															name="state_id"
															onChange={ (e: any) => this.changeUserAddress(e,() => {
																this.setState({
																	user_address: {
																		...this.state.user_address,
																		city_id: '',
																		municipality_id: ''
																	}
																},() => this.getCities());
															}) }
															value={ this.state.user_address.state_id }
															options={ this.state.states.map((i: any) => {
																return {
																	value: i.id,
																	label: i.name
																}
															}) } />
													</div>
													<div className="col-md-6">
														<Select
															label="Ciudad"
															disabled={ !this.state.user_address.state_id }
															name="city_id"
															onChange={ this.changeUserAddress }
															value={ this.state.user_address.city_id }
															options={ this.state.cities.map((i: any) => {
																return {
																	value: i.id,
																	label: i.name
																}
															}) } />
													</div>
													<div className="col-md-6">
														<Select
															label="Municipio"
															disabled={ !this.state.user_address.state_id }
															name="municipality_id"
															onChange={ this.changeUserAddress }
															value={ this.state.user_address.municipality_id }
															options={ this.state.municipalities.map((i: any) => {
																return {
																	value: i.id,
																	label: i.name
																}
															}) } />
													</div>
													<div className="col-md-6">
														<Input
															color="white"
															value={ this.state.user_address.address }
															name="address" 
															label="Dirección"
															placeholder="Indique la dirección completa"
															onChange={ this.changeUserAddress } />
													</div>
													<div className="col-md-6">
														<Input
															color="white"
															value={ this.state.user_address.indications }
															name="indications" 
															label="Indicaciones de la dirección"
															placeholder="Escribe aquí instrucciones o comentarios"
															onChange={ this.changeUserAddress } />
													</div>
													<div className="col-md-6">
														<Input
															color="white"
															value={ this.state.user_address.information }
															name="information" 
															label="Información adicional"
															placeholder="Ej: Piso/Oficina/Apto"
															onChange={ this.changeUserAddress } />
													</div>
													<div className="col-md-6">
														<Input
															color="white"
															value={ this.state.user_address.name }
															name="name" 
															label="Nombre de la dirección"
															placeholder="Nombre/Indicador de la dirección"
															onChange={ this.changeUserAddress } />
													</div>
												</div>

												{
													!error_map && (
														<React.Fragment>
															<label className="location-input-label">Indicar punto en el mapa</label>
															<input type="text" placeholder="Buscar dirección Google Mapas" id="location-input" />
														</React.Fragment>
													)
												}

												{
													!error_map && (
														<div id="map-request-quote"></div>
													)
												}

												{
													error_map && (
														<div className="location-permission">
															<p>Para el correcto funcionamiento de la página debe permitir el acceso a su ubicación</p>
														</div>
													)
												}

												<div className="row row-address">
													<div className="col-6">
														<Button type="button" className="btn-cancel-address" onClick={ (e: any) => this.setState({
															...DEFAULT_LOCATION,
															add_new: false
														}) }>
															Cancelar
														</Button>
													</div>
													<div className="col-6">
														<Button type="button" className="btn-submit-address" onClick={ (e: any) => {
															e.preventDefault();
															this.add();
														} }>
															Guardar dirección
														</Button>
													</div>
												</div>
											</React.Fragment>
										)
									}
								</div>

								<div className="container-dates">
									{
								    	this.state.days_selected.map((item: any, index: number) => {
								    		return (
								    			<div className="item-date">
								    				<p>{ moment(item).format('DD-MM-YYYY') }</p>
								    				<img src={ CloseIcon } onClick={ () => {
								    					let days_selected = [...this.state.days_selected];
								    					days_selected.splice(index,1);
								    					this.setState({
								    						days_selected
								    					});
								    				} } />
								    			</div>
								    		)
								    	})
								    }
								</div>

								<h5 style={{ marginTop: '15px' }}>Tipo de servicio</h5>
								<div className="row">
									{
										this.state.quote_types?.map((item: any) => {
											return (
												<div className="col-lg-3">
													<button className={ `item-service ${ this.state.form.type_id == item.id ? 'active' : '' }` } onClick={ () => {
														if (item.id == Constants.QUOTE_TYPES.URGENT && !this.state.urgent_available) {
															Globals.showError("Lo sentimos, no hay limpiezas urgentes disponibles para el día de hoy");
															return;
														}
														this.setState({
															form: {
																...this.state.form,
																type_id: item.id
															}
														},() => {
															if (this.state.form.type_id != Constants.QUOTE_TYPES.CUSTOM.toString() && this.state.form.type_id != Constants.QUOTE_TYPES.NORMAL.toString()) {
																let accessories: any = [...this.state.accessories];
																accessories.forEach((i: any) => i.quantity = 0)
																this.setState({
																	accessories
																},() => this.calculateSurcharges());
															}
														});
													} }>
														<img src={ Globals.isQuoteTypeBase(item.id) ? (Constants.BASE_PUBLIC + item.photo) : (Constants.BASE_STORAGE + item.photo) } />
														<p>{ item.name }</p>
													</button>
												</div>
											)
										})
									}
								</div>

								{
									service != null && (
										<div className="container-include">
											{
												quote_type?.recommendation && (
													<div className="container-recommendation">
														<p>{ quote_type?.recommendation }</p>
													</div>
												)
											}

											{
												(this.state.form.type_id == Constants.QUOTE_TYPES.DEEP.toString() || this.state.form.type_id == Constants.QUOTE_TYPES.URGENT.toString()) && (
													<div className="container-white">
														{/*<h5>Indique la cantidad</h5>*/}

														<div className="container-select-area">
															<label htmlFor="area">m2</label>
															<Input
																type="decimal"
																placeholder="0"
																name="area"
																className="form-group-deep"
																onChange={ this.change }
											                    value={ this.state.form.area } />
											                {/*{ this.state.form.type_id == Constants.QUOTE_TYPES.DEEP.toString() && <p className="message-deep">Limpieza desde { Globals.formatMiles(price_per_meter?.price * 100,true,Constants.CURRENCIES_SYMBOL.BOLIVAR,conversion || 0) }. Precio a partir de { price_per_meter?.minimum } metros cuadrados { Globals.formatMiles(price_per_meter?.price,true,Constants.CURRENCIES_SYMBOL.BOLIVAR,conversion || 0) }</p> }*/}
														</div>
													</div>
												)
											}

											{
												this.state.form.type_id == Constants.QUOTE_TYPES.DEEP.toString() && (
													<div className="container-files">
														<h3>Subir fotos del lugar a limpiar</h3>
														<div className="container-images">
															{
																this.state.photos.map((item: any, index: number) => {
																	return (
																		<div className="item-image" key={index}>
																			<button className="btn btn-delete-image" onClick={() => {
																				let photos = [...this.state.photos];
																				photos.splice(index, 1);
																				this.setState({
																					photos
																				});
																			}}>
																				<img src={CloseIcon} alt="Eliminar" />
																			</button>
																			{/* Evaluamos: si existe (is_existing) usamos la URL del servidor, 
																				si no, usamos la dataURL local generada por el input 
																			*/}
																			<img src={item?.is_existing ? item?.url : item?.dataURL} alt={`Foto del lugar ${index + 1}`} />
																		</div>
																	)
																})
															}
															{
																this.state.photos.length == 0 ? (
																	<div className="container-no-photos">
																		<PaperClip
																			onChange={ (e: any) => {
																				this.addPhoto(e.target);
																			} }>
																				<img src={ CameraIcon } /> 
																				<p>Máximo 10 fotos</p>
																		</PaperClip>
																	</div>
																) : (
																	<>
																		{
																			this.state.photos.length < MAX_PHOTOS && (
																				<div className="add-image">
																					<PaperClip
																						onChange={ (e: any) => {
																							this.addPhoto(e.target);
																						} }>
																							<img src={ AddWhiteIcon } />
																					</PaperClip>
																				</div>
																			)
																		}
																	</>
																)
															}
														</div>
													</div>
												)
											}

											{
												(this.state.form.type_id == Constants.QUOTE_TYPES.CUSTOM.toString() || !Globals.isQuoteTypeBase(this.state.form.type_id)) && (
													<>
														<h5 style={{ marginTop: '15px' }}>Áreas:</h5>
														<div className="row">
															{
																service?.service_areas?.map((item: any,index: number) => {
																	if ((this.state.form.type_id == Constants.QUOTE_TYPES.CUSTOM.toString() && item.type_id == null) || (!Globals.isQuoteTypeBase(this.state.form.type_id) && item.type_id == this.state.form.type_id)) 
																		return (
																			<div className="col-md-4">
																				<div className="item-service-area">
																					<h4>{ item.name } { item.limit != null && `(Máx ${ item.limit })` }</h4>
																					<div className="container-area-quantity">
																						<div className="container-input">
																							<p>Cant</p>
																							<Input 
																								type="number"
																								color="white"
																								placeholder="0"
																								value={ item.quantity || '' }
																								name="quantity"
																								onChange={ (e: any) => {
																									let service_areas: any = [...service?.service_areas];
																									service_areas[index].quantity = e.target.value;
																									this.setState({
																										service_areas
																									},() => this.calculateSurcharges());
																								} } />
																						</div>
																						<p className="price">{ Globals.formatMiles(item.price,true,Constants.CURRENCIES_SYMBOL.BOLIVAR,conversion || 0) }</p>
																					</div>
																				</div>
																			</div>
																		)
																})
															}
														</div>
													</>
												)
											}

											{
												service?.service_includes?.length > 0 && (
													<>
														{/*<div className="include">
															<img src={ IncludeImage } />
														</div>*/}

														<div className="row">
															{
																service?.service_includes?.map((item: any) => {
																	return (
																		<div className="col-md-6">
																			<div className="item-include">
																				<div className="row">
																					<div className="col-md-9">
																						<p>{ item.name }</p>
																					</div>
																					{
																						item.quantity != '' && item.quantity != null && (
																							<div className="col-md-3 text-right">
																								<p className="cant-container">Cant. <p className="cant">{ item.quantity }</p></p>
																							</div>
																						)
																					}
																				</div>
																			</div>
																		</div>
																	)
																})
															}
														</div>
													</>
												)
											}

											{
												this.state.form.type_id == Constants.QUOTE_TYPES.NORMAL.toString() && (
													<img src={ IncludeAllImage } className="include-all" />
												)
											}

											{/*<div style={{ marginTop: '20px' }}>
												<div className="container-marquee-included">
													{
														this.state.items_marquee_included.map((item: any) => {
															return (
																<div className="item-marquee-included">
																	<img src={ item } />
																</div>
															)
														})
													}
												</div>
												<div className="container-marquee-included">
													{
														this.state.items_marquee_not_included.map((item: any) => {
															return (
																<div className="item-marquee-included">
																	<img src={ item } />
																</div>
															)
														})
													}
												</div>
											</div>*/}
										</div>
									)
								}

								{
									this.state.accessories.length > 0 && (this.state.form.type_id == Constants.QUOTE_TYPES.CUSTOM.toString() || this.state.form.type_id == Constants.QUOTE_TYPES.NORMAL.toString()) && (
										<>
											<h5 style={{ marginTop: '15px' }}>Servicios adicionales</h5>
											<div className="row">
												{
													this.state.accessories.map((item: any,index: number) => {
														return (
															<div className="col-md-4">
																<div className="item-accessory">
																	<p>{ item.name }</p>
																	<div className="accessory-price">
																		<div className="row">
																			<div className="col-md-8">
																				<div className="container-input">
																					<p className="cant">Cant.</p>
																					<Input
																						type="number"
																						color="white"
																						placeholder="0"
																						value={ item.quantity || '' }
																						name="quantity"
																						onChange={ (e: any) => {
																							let accessories: any = [...this.state.accessories];
																							accessories[index].quantity = e.target.value;
																							this.setState({
																								accessories
																							},() => this.calculateSurcharges());
																						} } />
																				</div>
																			</div>
																			<div className="col-md-4 text-right">
																				<p>{ Globals.formatMiles(item.price,true,Constants.CURRENCIES_SYMBOL.BOLIVAR,conversion || 0) }</p>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														)
													})
												}
											</div>
										</>
									)
								}
							</div>
							<div className="col-lg-4">
								<TotalContainer />
							</div>
						</div>
					</>
				</div>
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user,
		default_address: state.default_address,
		surcharge_title: state.surcharge_title,
		quote_before_login: state.quote_before_login
	}
})(ClientRequestQuote);